import React from 'react'
import PropTypes from 'prop-types'
import { withFormsy } from 'formsy-react';

import 'react-image-crop/dist/ReactCrop.css';
import Frame from 'react-frame-component';

import Component from '../Component'
import DragAndDrop from "./DragAndDrop";
import PixieEditor from "../../../js/plugins/pixie/PixieEditor";

class ImageUpload extends Component {
    cropperRef = React.createRef();

    static DefaultWidth = 250;

    static defaultPropTypes = {
        ratio: '1:1'
    }


    static propTypes = {
        label: PropTypes.string,
        source: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        width: PropTypes.number,
        height: PropTypes.number,
        ratio: PropTypes.string,
        circular: PropTypes.bool,
        onError: PropTypes.func,
    };


    static defaultProps = {
        label: 'Image',
    };

    getAspectRatio() {
        switch (this.props.ratio) {
            case '1:1':
                return 1;
            case '16:9':
                return 16 / 9;

        }
    }

    constructor(props) {
        super(props);
        let previewUrl = { ...props }.source;
        if (previewUrl && TB.isObject(previewUrl)) {
            previewUrl = window.URL.createObjectURL(previewUrl);
        }

        this.state = {
            ...this.state,
            file: '',
            previewUrl,
            uploadSrc: null,
            originalSrc: { ...props }.source,
            previewImgStyle: {},
            crop: {
                unit: '%', // default, can be '%' or 'px'
                height: 50,
                x: 25,
                y: 25,
                aspect: props.ratio
            },
            freeCrop: props.freeCrop,
            minWidth: props.minWidth,

            maxWidth: props.maxWidth
        };
    }


    async componentDidMount()
    {
        if (this.state.croppedImageUrl || this.state.source) {
            let previewImgStyle = await this.getImageDimensions(this.state.croppedImageUrl ||
                (TB.isObject(this.state.source) ? this.state.previewUrl : this.state.source)
            )

            this.setState({ previewImgStyle })
        }
        await super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount()
    }

    saveImage = async(fileUrl,blob) => {
        await this.promisedState({
            croppedImageUrl: fileUrl,
            croppedFile: blob
        });
        console.log('confirmCrop', this.state.croppedFile)
        this.props.setValue(this.state.croppedFile);

    };

    loadImageFromSrc(src) {
        return new Promise(async (resolve, reject) => {
            let img = new Image();
            img.src = src;
            img.onload = () => {
                if (img) resolve(img)
            };
            img.onerror = () => {
                resolve(false)
            };
        });
    }

    async getImageDimensions(src) {
        let img = await this.loadImageFromSrc(src);
        if (!img) {
            return {}
        }
        let maxWidth = 600, maxHeight = 600 / this.getAspectRatio();
        let targetWidth = img.offsetWidth,
            targetHeight = img.offsetHeight;
        if (targetWidth > maxWidth || targetHeight > maxHeight) {
            if (targetWidth / targetHeight > maxWidth / maxHeight) {
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (targetHeight / targetWidth));
            } else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (targetWidth / targetHeight));
            }
        }
        if (this.getAspectRatio() === 1) {
            if (targetWidth < targetHeight) {
                targetHeight = targetWidth;
            }else {
                targetWidth = targetHeight;
            }
        }

        return {
            height: targetHeight,
            width: targetWidth
        }
    }

    cancelCrop = async () => {

        window.URL.revokeObjectURL(this.state.croppedImageUrl);

        this.setState({
            isCropping: false,
            croppedImageUrl: null,
            uploadSrc: null,
            croppedFile: null
        }, async () => {
            if (this.state.originalSrc) {
                let previewImgStyle = await this.getImageDimensions(this.state.originalSrc);
                await this.promisedState({ previewImgStyle })
                this.props.setValue(this.state.originalSrc);
            } else {
                this.props.setValue(null)
            }
        });
    };

    onSelectFile = files => {
        if (files && files.length > 0) {
            const reader = new FileReader(), file = files[0];
            reader.addEventListener('load', () => {

                this.setState({
                    uploadSrc: reader.result,
                    isCropping: true
                }, () => this.setState({showEditor: true}));
            });
            reader.readAsDataURL(file);
        }
    };

    imageFrame() {
        let { width, height } = this.props;

        let ratio = this.getAspectRatio();
        let frame = {
            width,
            height
        };

        if (!frame.width && !frame.height) {
            frame.width = this.constructor.DefaultWidth;
        }


        if (!ratio) {
            return frame;
        }

        if (frame.height) {
            frame.width = frame.height * ratio;
            return frame;
        }

        frame.height = frame.width / ratio;
        return frame;
    }

    render() {
        let previewStyle = {
            ...this.imageFrame(),
            ...this.state.previewImgStyle,
            backgroundRepeat: 'no-repeat'
        };

        let { crop, croppedImageUrl, isCropping, previewUrl } = this.state;
        let {
            circular,
            getErrorMessage,
            isFormSubmitted,
            showRequired,
            showError,
            source,
            ratio = this.getAspectRatio() || crop.aspect,
            disabled
        } = this.props;


        crop.aspect = ratio;

        if (circular) {
            previewStyle.borderRadius = '50%';
        }


        if (croppedImageUrl || source) {
            // previewStyle.backgroundColor = '#EAEAEA';
            previewStyle.backgroundImage = `url("${croppedImageUrl || (TB.isObject(source) ? previewUrl : source)}")`;
            if (TB.isMobile() && this.props.shouldResize) {
                previewStyle.width = '100%';
            }
        }

        let errorClass = isFormSubmitted() &&
            (showRequired() || showError()) ?
            'is-invalid' :
            null;

        return (
            <div
                className={`image-upload-container form-group ${errorClass ? 'text-danger' : ''} ${disabled && 'disabled'}`}>
                <label className="col-form-label" data-required="true">
                    {this.props.label}
                    {this.props.required && <span className="required-symbol"> *</span>}
                </label>
                {this.props.labelHint && (
                    <p className="label-hint">
                        {this.props.labelHint}
                    </p>
                )}
                {(croppedImageUrl || source) ? [
                    this.props.dropContainer ? (
                        <div key="image-upload-preview-sourced"  className={"image-upload-preview preview-drop-container " + (circular && 'img-grayscale')}>

                            <div key="iupc"
                                 className={`btn-file form-component ${errorClass}`}>
                                {this.props.dropContainer}

                                <div className="image-edit-btn">
                                    <i className="fa fa-edit" />
                                </div>
                                {!disabled && !isCropping && (
                                    <input
                                        name={this.props.name}
                                        type="file"
                                        title=" "
                                        accept="image/*"
                                        onChange={e => this.onSelectFile(e.target.files)} />
                                )}
                            </div>
                        </div>
                    ) : (
                       <div key="image-upload-preview-sourced" style={{backgroundImage: 'url("/static/pixie/assets/images/empty-canvas-bg.png")',opacity: 1}}>
                           <div style={previewStyle}
                                className={"image-upload-preview m-0 " + (circular && 'img-grayscale')}>

                               {!disabled && (
                                   <div key="iupc"
                                        className={`btn-file form-component ${errorClass}`}>

                                       <div className="image-edit-btn">
                                           <i className="fa fa-edit" />
                                       </div>
                                       {!isCropping && (
                                           <input
                                               name={this.props.name}
                                               type="file"
                                               title=" "
                                               accept="image/*"
                                               onChange={e => this.onSelectFile(e.target.files)} />
                                       )}
                                   </div>
                               )}

                           </div>
                       </div>
                    ),

                ] : (
                        <DragAndDrop
                            dropContainer={this.props.dropContainer}
                            handleDrop={this.onSelectFile} disabled={this.props.disabled}
                            name={this.props.name} />
                    )}


                {this.renderCropper()}

                <div className="invalid-feedback">
                    <div>{getErrorMessage()}</div>
                </div>

            </div>
        )
    }

    renderCropper() {
        let { crop, croppedImageUrl, uploadSrc } = this.state;
        let {
            circular,
            ratio = this.getAspectRatio() || crop.aspect,
            freeCrop,
            minWidth,
            minHeight
        } = this.props;

        crop.aspect = freeCrop ? undefined : ratio;
        let previewStyle = this.imageFrame();
        if (circular) {
            previewStyle.borderRadius = '50%';
            previewStyle.overflow = 'hidden';
        }

        if (!this.state.showEditor) {
            return null
        }else {
            return (
                <React.Fragment>
                    {uploadSrc && (
                        <Frame
                            style={{zIndex: 50000,height: '100%', width: '100%',position:'fixed', top: '0px', bottom: '0px', right: '0px', left: '0px'}}
                            initialContent={String(`
                                <!DOCTYPE html>
                                <html>
                                <head>  
                                <style type="text/css">
                                    html, body {font-family: "Beatrice", sans-serif;}
                                   .pi .z-navbar label.select-none {
                                       pointer-events: none;
                                   }
                                   .pi .cursor-sw-resize {
                                        border-color: black!important;
                                    }
                                   .pi .cursor-se-resize {
                                       border-color: black!important;
                                   }
                                   .pi .cursor-nwse-resize {
                                       border-color: black!important;
                                   }
                                   .pi .cursor-nesw-resize {
                                       border-color: black!important;
                                   }
                                   
                                </style>
                                <script src="/static/pixie/dist/pixie.umd.js"></script>
                                </head>
                                <body>
                                    <div id="pixieMount"></div>
                                </body>
                                </html>`).trim()}
                            mountTarget='#pixieMount'
                        >
                            <PixieEditor
                                source={uploadSrc}
                                maxWidth={this.props.maxWidth}
                                onSave={this.saveImage}
                                onClose={async () => {
                                    await this.promisedState({ isCropping: false })
                                    await TB.wait(400)

                                    await this.setState({showEditor: false})
                                }}
                                onCancel={this.cancelCrop}
                                ratio={this.props.ratio}
                            />
                        </Frame>
                    )}
                </React.Fragment>
            )
        }
    }

    getCroppedImg(image, crop, fileName) {

        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        let originWidth = crop.width * scaleX;
        let originHeight = crop.height * scaleY;
        // maximum width/height
        let maxWidth = 2048, maxHeight = 2048 / this.getAspectRatio();
        let targetWidth = originWidth,
            targetHeight = originHeight;
        if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
        }
        // set canvas size
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            ((crop.x - 20) * scaleX),
            ((crop.y - 20) * scaleY),
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            targetWidth,
            targetHeight
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error('Canvas is empty');
                    return;
                }
                blob.name = fileName;

                window.URL.revokeObjectURL(this.state.fileUrl);

                let fileUrl = window.URL.createObjectURL(blob);

                resolve({
                    fileUrl,
                    blob
                });
            }, 'image/png');
        });
    }

}

export default withFormsy(ImageUpload);